import React from "react";
import { Button as HeroUiButton } from "@heroui/react";
import ButtonLoad from "./ButtonLoad";

const Button = ({
    children,
    type,
    click,
    buttonType = "heroui",
    loading = false,
}) => {
    if (buttonType == "tailwind") {
        if (loading) {
			<ButtonLoad />
        } else {
            return (
                <button
                    type={type}
                    onClick={click}
                    className="text-white_m-200 bg-black_m-300 dark:bg-black_m-400 hover:bg-black_m-200 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-sm text-sm w-full px-5 py-3 text-center"
                >
                    {children}
                </button>
            );
        }
    }

    if (buttonType == "heroui") {
        return (
            <HeroUiButton
                radius="sm"
                type={type}
                fullWidth
                size="md"
                onPress={click}
                className="bg-black_m-300 dark:bg-black_m-400 text-white_m-200 shadow-lg text-base py-6"
                isLoading={loading}
            >
                {loading ? 'Loading' : children}
            </HeroUiButton>
        );
    }
};

export default Button;
